import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-trident",
  templateUrl: "./med-icon-trident.component.html",
})
export class MedIconTridentComponent extends SvgMixinComponent {
  private readonly RESIZE: number = 1.75; // sizes of trident are 24.40 or width.width*1.75

  get tridentHeight(): number {
    return parseInt(this.size, 10) * this.RESIZE;
  }
}
